import React, { useCallback } from 'react';
import ActionButtons from 'pages/PPALeadFormPage/components/ActionButtons';
import s from './s.module.less';

interface FooterProps {
    showBack?: boolean;
    onBack?: () => void;
    onNext?: () => void;
    nextDisabled?: boolean;
    nextLoading?: boolean;
    nextLabel?: string;
    nextFormId?: string;
    showNext?: boolean;
    onSkip?: () => void;
    skipLabel?: string;
}

const Footer: React.FC<FooterProps> = ({
    showBack = true,
    onBack,
    onNext,
    nextDisabled,
    nextLoading,
    nextLabel = 'Next',
    nextFormId,
    showNext = true,
    onSkip,
    skipLabel = 'Skip for now',
}) => {
    const handleNext = useCallback(() => {
        if (nextFormId) {
            const form = document.getElementById(nextFormId) as HTMLFormElement | null;
            if (form) {
                if (typeof form.requestSubmit === 'function') {
                    form.requestSubmit();
                } else {
                    form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
                }
                return;
            }
        }
        onNext?.();
    }, [nextFormId, onNext]);

    return (
        <div className={s.footer}>
            <ActionButtons
                showBack={showBack}
                onBack={onBack}
                onNext={handleNext}
                nextDisabled={nextDisabled}
                nextLoading={nextLoading}
                nextLabel={nextLabel}
                showNext={showNext}
                currentStep={2}
            />
            {onSkip && (
                <button type="button" className={s.skip} onClick={onSkip}>
                    {skipLabel}
                </button>
            )}
        </div>
    );
};

export default Footer;
